import { ClientRole } from 'src/client/types/client-role.enum'
import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw = {
  name: 'client.payments',
  path: 'payments',
  component: () => import('src/client/pages/PaymentInfo.vue'),
  meta: {
    roles: [Roles.Client],
    clientRoles: [ClientRole.PortalMember, ClientRole.Sponsor],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}

export default routeRecord
